import { AlertTriangle } from 'lucide-react';
import { Component, type ErrorInfo, type ReactNode } from 'react';

import { Button } from '@/shared/ui/shadcn/button';

type Props = { children: ReactNode; fallback?: ReactNode };
type State = { error: Error | null };

export class ErrorBoundary extends Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: ErrorInfo) {
    console.error('[ErrorBoundary]', error, info);
  }

  reset = () => this.setState({ error: null });

  override render() {
    if (this.state.error) {
      if (this.props.fallback) return this.props.fallback;
      return (
        <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 p-6 text-center">
          <AlertTriangle aria-hidden="true" className="size-10 text-destructive" />
          <div className="space-y-1">
            <h2 className="text-lg font-semibold">Algo salió mal</h2>
            <p className="max-w-md text-sm text-muted-foreground">
              {this.state.error.message || 'Error inesperado. Intenta nuevamente.'}
            </p>
          </div>
          <div className="flex gap-2">
            <Button onClick={this.reset}>Reintentar</Button>
            <Button
              variant="outline"
              onClick={() => {
                navigator.clipboard.writeText(this.state.error?.stack ?? '').catch(() => undefined);
              }}
            >
              Copiar detalle
            </Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
